import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceHappy32Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFaceHappy32Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12m-3.5-13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m8.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-10.447 4.606a1 1 0 0 1 1.34.442l.005.011.037.066c.036.062.094.157.175.273.164.235.414.552.756.867C13.544 20.391 14.563 21 16 21s2.456-.609 3.134-1.235a5.4 5.4 0 0 0 .756-.867 4 4 0 0 0 .212-.339l.006-.01h-8.216 8.216a1 1 0 0 1 1.786.898L21 19l.894.448v.001l-.002.002-.002.005-.007.013-.02.04-.07.124c-.06.102-.146.242-.26.406a7.4 7.4 0 0 1-1.042 1.196C19.544 22.109 18.063 23 16 23s-3.544-.891-4.49-1.765a7.3 7.3 0 0 1-1.042-1.196 6 6 0 0 1-.33-.53l-.021-.04-.007-.013-.002-.005-.002-.002c0-.001 0-.002.894-.449l-.894.447a1 1 0 0 1 .447-1.341"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceHappy32Filled);
